/* eslint-disable react/prop-types */
import * as React from 'react';

import { Tabs } from 'antd';

import { cn } from 'utils';

const PrimitiveTabs = ({
  destroyInactiveTabPane = false,
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof Tabs>) => (
  <Tabs
    destroyInactiveTabPane={destroyInactiveTabPane}
    className={cn(
      '[&>div]:px-6 first-of-type:[&>div]:pt-3 last-of-type:[&>div]:py-3',
      className,
    )}
    {...props}
  />
);

export { PrimitiveTabs };
